import { Box, Divider } from '@wix/design-system';
import t__default, { useContext } from 'react';
import { RicosContext } from 'ricos-context';
import { LINE_SPACING_INPUT, BEFORE_PARAGRAPH_INPUT, AFTER_PARAGRAPH_INPUT } from '../data-hooks.js';
import { InputWithLabel } from './input-with-label/input-with-label.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const CustomSpacingEditor = ({
  lineSpacing,
  setLineSpacing
}) => {
  const { t, isMobile } = useContext(RicosContext);
  return /* @__PURE__ */ t__default.createElement(Box, { direction: "vertical", width: isMobile ? "100%" : "250px" }, /* @__PURE__ */ t__default.createElement(Box, { direction: "vertical", padding: "18px 24px", gap: "15px" }, /* @__PURE__ */ t__default.createElement(
    InputWithLabel,
    {
      label: t("LineSpacing_lineSpacing"),
      value: lineSpacing["line-height"],
      onChange: (value) => {
        setLineSpacing(__spreadProps(__spreadValues({}, lineSpacing), { "line-height": value }));
      },
      min: 1,
      max: 100,
      dataHook: LINE_SPACING_INPUT
    }
  ), /* @__PURE__ */ t__default.createElement(Divider, null), /* @__PURE__ */ t__default.createElement(
    InputWithLabel,
    {
      label: t("LineSpacing_beforeParagraph"),
      value: lineSpacing["padding-top"],
      onChange: (value) => {
        setLineSpacing(__spreadProps(__spreadValues({}, lineSpacing), { "padding-top": value }));
      },
      min: 0,
      max: 250,
      dataHook: BEFORE_PARAGRAPH_INPUT
    }
  ), /* @__PURE__ */ t__default.createElement(
    InputWithLabel,
    {
      label: t("LineSpacing_afterParagraph"),
      value: lineSpacing["padding-bottom"],
      onChange: (value) => {
        setLineSpacing(__spreadProps(__spreadValues({}, lineSpacing), { "padding-bottom": value }));
      },
      min: 0,
      max: 250,
      dataHook: AFTER_PARAGRAPH_INPUT
    }
  )));
};

export { CustomSpacingEditor };
//# sourceMappingURL=custom-spacing-editor.js.map
